import { Pipe, PipeTransform } from '@angular/core';
import { PGIService } from '../services/pgi.service';

@Pipe({
    name: 'renameTextForMobile'
})
export class RenameTextForMobilePipe implements PipeTransform {

    constructor(private pgiService: PGIService) { }

    private labels = {
        'policies in force': 'PIF',
        'written premium': 'WP',
        'new business wp': 'NB WP',
        'line of business': 'LOB',
        'percent of total': 'Percent',
        'prior year wp': 'PY WP',
        'homeowners policies by fire protection class': 'Home PIF by Fire Protection Class',
        'lessthanhighschooldiploma': 'NoHighSchoolDiploma',
        'somecollegenodegree': 'SomeCollege',
        'gross commission trend by month & year over year': 'Commission Trend by Month & YoY',
        '% total book by premium': '% Total Premium',
        'ytd written premium': 'YTD WP',
        'ytd loss ratio': 'YTD LR',
        'yoy loss ratio change': 'YoY LR Change',
        '2024 ye loss ratio': '24 YE LR',
        '2023 ye loss ratio': '23 YE LR',
        '2022 ye loss ratio': '22 YE LR',
        'auto (personal)': 'Auto',
        'dwelling fire': 'DP',
        'homeowners': 'Home',
        'umbrella - personal': 'Umb',
        'watercraft (small boat)': 'Boat',
        'inland marine (pers)': 'IM',
        'auto (commercial)': 'CL Auto',
        'commercial pkg': 'CL Pkg',
        'business owners policy': 'BOP',
        'commercial prpty': 'CL Prpty',
        'genl liability': 'GL',
        'motor truck cargo': 'MTC',
        'umbrella - comm': 'CL Umb',
        'workers comp': 'WC',
    } as const;

    transform(value: string): string {
        if (this.pgiService.isWebview) {
            if (!value) return value;

            // Use the mapping object instead of switch
            return this.labels[value.toLowerCase()] || value;
        }
        return value;
    }
}